export function SeoContent() {
  return (
    <section className="mt-10 pt-8 border-t-2 border-foreground" data-testid="seo-content" aria-label="About Card Counter">
      <div className="max-w-3xl space-y-8">
        <div>
          <h2 className="font-cabinet font-black text-2xl sm:text-3xl tracking-tight leading-tight mb-3">
            A free, private card and deck tracker for every table
          </h2>
          <p className="text-sm leading-relaxed text-muted-foreground">
            Card Counter is a lightweight, single-page utility that helps online and home card
            players keep an accurate picture of the shoe. Choose one, two, three, or four decks,
            then click or tap each card as it is dealt. The grid instantly dims played cards and the
            stats panel recalculates in real time, so you always know exactly what is left. There is
            no sign-up, no account, and no data leaves your device — your session is saved right in
            your browser and survives a refresh.
          </p>
        </div>

        <div>
          <h3 className="font-cabinet font-bold text-xl tracking-tight mb-3">How to use the card counter</h3>
          <ol className="text-sm leading-relaxed text-muted-foreground space-y-2 list-decimal pl-5">
            <li>Select how many decks are in play using the deck selector (1–4 decks).</li>
            <li>Click a card in the grid — or use the keyboard — the moment it is dealt at the table.</li>
            <li>Watch the live stats: total remaining, total dealt, and remaining cards by suit and by rank.</li>
            <li>Made a mistake? Undo any number of steps, or reset the whole shoe with a single confirmation.</li>
            <li>Switch table themes, mute the deal sound, and toggle the optional Hi-Lo count whenever you like.</li>
          </ol>
        </div>

        <div>
          <h3 className="font-cabinet font-bold text-xl tracking-tight mb-3">Features at a glance</h3>
          <ul className="text-sm leading-relaxed text-muted-foreground space-y-2 list-disc pl-5">
            <li><strong className="text-foreground">Full shoe tracking</strong> for 1 to 4 decks with per-card remaining counts.</li>
            <li><strong className="text-foreground">Live statistics</strong> for remaining and dealt totals plus breakdowns by suit and rank.</li>
            <li><strong className="text-foreground">Optional Hi-Lo count</strong> showing a running count and true count for Blackjack players.</li>
            <li><strong className="text-foreground">Deal speed</strong> in cards per minute and a <strong className="text-foreground">shoe-depth</strong> progress bar.</li>
            <li><strong className="text-foreground">Keyboard shortcuts</strong>, undo history, a deal log, and five table themes.</li>
            <li><strong className="text-foreground">Fully client-side</strong> and private — nothing is uploaded and no account is required.</li>
          </ul>
        </div>

        <div>
          <h3 className="font-cabinet font-bold text-xl tracking-tight mb-3">Frequently asked questions</h3>
          <div className="space-y-4 text-sm leading-relaxed text-muted-foreground">
            <div>
              <p className="text-foreground font-bold">Is Card Counter free to use?</p>
              <p>Yes. Card Counter is completely free, runs entirely in your browser, and never asks you to create an account.</p>
            </div>
            <div>
              <p className="text-foreground font-bold">Does it work on mobile and tablet?</p>
              <p>Absolutely. The layout is responsive with large tap targets, so it works well on phones, tablets, and desktops alike.</p>
            </div>
            <div>
              <p className="text-foreground font-bold">Will my progress be saved if I refresh?</p>
              <p>Yes. Your deck count, dealt cards, and preferences are stored locally in your browser and restored automatically when you return.</p>
            </div>
            <div>
              <p className="text-foreground font-bold">What is the Hi-Lo count?</p>
              <p>Hi-Lo is a popular Blackjack card-counting system. When enabled, Card Counter shows the running count and the true count based on the cards you have marked as dealt. It is optional and off by default.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
